module.exports = __webpack_public_path__ + "static/logodark-d86ee889211156c136b291cc0ec22e05.png";